import * as _ from 'lodash';
import guid from './guid';

function nextScriptNameGenerator(name, items) {
    let resultName = name,
        nameNumberPart = 0,
        namePartNumbers = [];

    const existingItemWithSimilarName = _.filter(items, function (el) {
        return el.indexOf(resultName) >= 0;
    });

    const existingItemWithSameName = _.filter(items, function (el) {
        return el === resultName;
    });

    for (var i = 0; i < existingItemWithSimilarName.length; i++) {
        const nameParts = existingItemWithSimilarName[i].split('_');
        const partNumber = nameParts[nameParts.length - 1];
        if (partNumber) {
            if (!_.isNaN(+partNumber)) {
                namePartNumbers.push(+partNumber);
            }
        }
    }

    if (existingItemWithSimilarName.length > 0 && existingItemWithSameName.length > 0) {
        if (namePartNumbers.length > 0) {
            nameNumberPart = Math.max.apply(null, namePartNumbers) + 1;

            if (nameNumberPart > Number.MAX_SAFE_INTEGER) {
                resultName += '_' + guid();
                resultName = resultName.replace(/-/gi, '_');
            } else {
                resultName += '_' + nameNumberPart;
            }
        } else {
            nameNumberPart = 2;
            resultName += '_' + nameNumberPart;
        }
    }
    return resultName;
}

export default nextScriptNameGenerator;
